import { File } from '../../types'

interface FilesState {
  contentFiles: { [key: string]: File } | null
  filesDownloadLinks: object
  filesRendered: object
}

const state: FilesState = {
  contentFiles: null,
  filesDownloadLinks: {},
  filesRendered: {},
}

export { FilesState, state }
